export const trendClass = (trend) => {
  if (trend === "increased") return "kbv-v24-odt-odds--up";
  if (trend === "decreased") return "kbv-v24-odt-odds--down";
  return "";
};
